import { ReactNode } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";

type Props = {
  children: ReactNode;
};

const Layout = ({ children }: Props) => {
  return (
    <>
      <CssBaseline />
      <Container maxWidth="sm" disableGutters>
        {children}
      </Container>
    </>
  );
};

export default Layout;
